export default "__VITE_ASSET__f9564f90__"